const MARKETING_URL = import.meta.env.VITE_MARKETING_URL || 'https://unplug-app.com';

export function InvalidSubdomainPage() {
  const hostname = window.location.hostname;

  return (
    <div class="error-page">
      <div class="error-card">
        <div class="error-icon">
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            <path d="M12 9v4m0 4h.01" />
          </svg>
        </div>

        <h1 class="error-title">Invalid Address</h1>

        <p class="error-message">
          The URL <strong>{hostname}</strong> is not a valid workspace address.
        </p>

        <p class="error-details">
          Workspace addresses should look like:
          <code>your-workspace.unplug-app.com</code>
        </p>

        <div class="error-actions">
          <a href={MARKETING_URL} class="btn btn-primary">
            Go to Unplug Home
          </a>
        </div>

        <p class="error-help">
          Need help finding your workspace?
          Ask your administrator or check your Slack for the dashboard link.
        </p>
      </div>

      <style>{`
        .error-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--gray-50);
          padding: 1rem;
        }

        .error-card {
          background: white;
          border-radius: 1rem;
          padding: 3rem;
          max-width: 480px;
          width: 100%;
          text-align: center;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        }

        .error-icon {
          color: var(--orange-500);
          margin-bottom: 1.5rem;
        }

        .error-title {
          font-size: 1.5rem;
          font-weight: 600;
          color: var(--gray-900);
          margin-bottom: 1rem;
        }

        .error-message {
          color: var(--gray-600);
          margin-bottom: 1rem;
          line-height: 1.6;
        }

        .error-message strong {
          color: var(--gray-900);
          font-family: monospace;
          background: var(--gray-100);
          padding: 0.125rem 0.5rem;
          border-radius: 0.25rem;
        }

        .error-details {
          color: var(--gray-500);
          font-size: 0.875rem;
          margin-bottom: 2rem;
        }

        .error-details code {
          display: block;
          margin-top: 0.5rem;
          background: var(--gray-100);
          padding: 0.5rem 1rem;
          border-radius: 0.375rem;
          font-family: monospace;
          color: var(--gray-700);
        }

        .error-actions {
          display: flex;
          gap: 1rem;
          justify-content: center;
          margin-bottom: 2rem;
        }

        .error-help {
          font-size: 0.875rem;
          color: var(--gray-500);
        }
      `}</style>
    </div>
  );
}
